// "/pure", как в референсе (StripePaymentForm.js): обычный
// "@stripe/stripe-js" инжектит скрипт js.stripe.com в <head> сам, как
// побочный эффект импорта модуля, т.е. на КАЖДОЙ странице, даже если зритель
// не открывал оплату. "/pure" не грузит скрипт, пока не вызван сам
// loadStripe(): только при открытии чекаута или замены карты. `Stripe` это
// тип, импорт типов стирается компилятором целиком.
import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

// Stripe.js docs warn against calling loadStripe() more than once: cache the
// resulting promise per publishable key so remounts (re-opening the checkout
// or the card dialog) reuse the same Stripe instance.
let stripePromiseCache: {
  key: string;
  promise: Promise<Stripe | null>;
} | null = null;

export function getStripePromise(
  publishableKey: string,
): Promise<Stripe | null> {
  if (stripePromiseCache?.key === publishableKey) {
    return stripePromiseCache.promise;
  }
  const promise = loadStripe(publishableKey);
  stripePromiseCache = { key: publishableKey, promise };
  return promise;
}
